import api, { unwrap } from './client';
import type { ApiResponse, PageResponse, SearchParams } from '@/types/api';

export interface DiscountDto {
  id: number;
  uuid: string;
  name: string;
  discountType: string;
  value: number;
  productId?: number;
  minCartAmount?: number;
  startDate?: string;
  endDate?: string;
  festivalOffer?: boolean;
  status: boolean;
}

export interface CouponDto {
  id: number;
  uuid: string;
  code: string;
  discountType: string;
  value: number;
  maxUses?: number;
  usedCount?: number;
  startDate?: string;
  endDate?: string;
  status: boolean;
}

export interface DiscountRequest {
  name: string;
  discountType: string;
  value: number;
  productId?: number;
  minCartAmount?: number;
  startDate?: string;
  endDate?: string;
  festivalOffer?: boolean;
  status?: boolean;
}

export interface CouponRequest {
  code: string;
  discountType: string;
  value: number;
  maxUses?: number;
  startDate?: string;
  endDate?: string;
  status?: boolean;
}

export const discountsApi = {
  list: (params?: SearchParams) =>
    unwrap(api.get<ApiResponse<PageResponse<DiscountDto>>>('/v1/discounts', { params })),

  get: (uuid: string) =>
    unwrap(api.get<ApiResponse<DiscountDto>>(`/v1/discounts/${uuid}`)),

  create: (data: DiscountRequest) =>
    unwrap(api.post<ApiResponse<DiscountDto>>('/v1/discounts', data)),

  update: (uuid: string, data: DiscountRequest) =>
    unwrap(api.put<ApiResponse<DiscountDto>>(`/v1/discounts/${uuid}`, data)),

  remove: (uuid: string) =>
    unwrap(api.delete<ApiResponse<null>>(`/v1/discounts/${uuid}`)),

  listCoupons: (params?: SearchParams) =>
    unwrap(api.get<ApiResponse<PageResponse<CouponDto>>>('/v1/discounts/coupons', { params })),

  validateCoupon: (code: string) =>
    unwrap(api.get<ApiResponse<CouponDto>>(`/v1/discounts/coupons/validate/${code}`)),

  createCoupon: (data: CouponRequest) =>
    unwrap(api.post<ApiResponse<CouponDto>>('/v1/discounts/coupons', data)),

  updateCoupon: (uuid: string, data: CouponRequest) =>
    unwrap(api.put<ApiResponse<CouponDto>>(`/v1/discounts/coupons/${uuid}`, data)),

  removeCoupon: (uuid: string) =>
    unwrap(api.delete<ApiResponse<null>>(`/v1/discounts/coupons/${uuid}`)),
};
